import React from "react";
import { BookOpenIcon, CheckIcon, TargetIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { volumes } from "../../data/volumes";
export function VolumesSection() {
  return <section className="bg-ink px-4 py-16 sm:py-24" data-id="element-329" data-mp="2mwzp8aoccbkm">
      <div className="mx-auto max-w-6xl" data-id="element-330" data-mp="2rsyk8h46cru0">
        <SectionHeading kicker="What's inside The ClinCheck Blueprint™" title={<>
              <span className="text-brand" data-id="element-332" data-mp="2itbifu7j9k0f">6 Specialized Blueprints</span> to organize your clinical planning
            </>} intro="Each volume addresses a different stage of clear aligner planning. The objective isn't to replace your clinical judgment — it's to help you structure your review, document observations, and identify questions that deserve further evaluation." data-id="element-331" data-mp="2rw2unw88gjt4" />

        <div className="mt-12 grid gap-5 lg:grid-cols-2 lg:gap-6" data-id="element-333" data-mp="1z52qnl9wjg1g">
          {volumes.map(v => <article key={v.number} className="flex flex-col rounded-3xl bg-navy p-5 ring-1 ring-line sm:p-8" data-id="element-334" data-mp="1fj088aw1em5f">
              <div className="flex items-center gap-2" data-id="element-335" data-mp="1akozk3hhahos">
                <span className="flex items-center gap-1.5 rounded-lg bg-brand px-3 py-1 text-sm font-black uppercase text-ink" data-id="element-336" data-mp="1am9s5nk8fqk0">
                  <BookOpenIcon className="h-4 w-4" aria-hidden="true" data-id="element-337" data-mp="1kimn0orikagc" />
                  {v.number}
                </span>
              </div>
              <h3 className="mt-4 font-display text-2xl font-extrabold leading-tight text-white sm:text-[28px]" data-id="element-338" data-mp="wtk47dl58bk9">{v.title}</h3>
              <p className="mt-2 text-[17px] font-bold text-brandsoft" data-id="element-339" data-mp="rrl4cdom3ws2">{v.subtitle}</p>
              <p className="mt-3 text-base leading-relaxed text-white/70" data-id="element-340" data-mp="16jwqba8lwcsi">{v.intro}</p>

              <p className="mt-5 text-sm font-bold uppercase text-white/60" data-id="element-341" data-mp="11qan08oc1l9d">Inside, you'll find:</p>
              <ul className="mt-3 space-y-2.5" data-id="element-342" data-mp="e0q39nkcujz1">
                {v.items.map(item => <li key={item} className="flex gap-2.5 text-base leading-snug text-white/90" data-id="element-343" data-mp="92es99ibq3f8">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-344" data-mp="yqk8k98adnu2" />
                    {item}
                  </li>)}
              </ul>

              <div className="mt-auto pt-6" data-id="element-345" data-mp="17kyidwa1s65s">
                <div className="flex gap-3 rounded-2xl bg-ink/70 p-4" data-id="element-346" data-mp="1ciqmrprvpkqv">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-347" data-mp="1chypmaimveyh" />
                  <p className="text-[15px] leading-relaxed text-white/85" data-id="element-348" data-mp="fual4vbhvkxe">
                    <span className="font-extrabold text-gold" data-id="element-349" data-mp="juuhhwo8ukih">The objective: </span>
                    {v.objective}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-350" data-mp="ttjy7m4elyx5">
          <CTAButton label="I want all 6 blueprints" sublabel="Only $27 · One-time payment" data-id="element-351" data-mp="208ky22wjv190" />
        </div>
      </div>
    </section>;
}